module.exports = "img/flags/LB.18e49e9.png";